// extracted by mini-css-extract-plugin
export default {"line":"styles_line__Lvyw-","container":"styles_container__F9eH3","text":"styles_text__axNeS","image":"styles_image__mx4S7"};